import React, {useEffect} from 'react';
import FileUpload from "../../../../components/sales/fileUpload/fileUpload";
import localization from "../../../../assets/localization/localization";

const MemberDetails = ({
                           addMembers = 1,
                           handleInputChange,
                           inputMemberList,
                           documentUploadUrl,
                           documentUrlData,
                           saveImage,
                           handleRemoveClick,
                           handleAddClick,
                            isEdit
                       }) => {

    let viewDetails = JSON.parse(localStorage.getItem('viewDetail'))

    useEffect(() => {
        if(isEdit && viewDetails !== null && viewDetails !== undefined){
            viewDetails[0]?.members.map((val, i) => {
                saveImage(val?.image_url, i)
            })
        }
    },[])
    return (
        <>

            {addMembers === 1 ? (
                <>
                    {console.log(addMembers)}
                    {inputMemberList.map((x, i) => {
                        return (
                            <div className="row form-group" key={i}>
                                <div className="col-md-2 col-sm-12">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="first_name"
                                        placeholder="First Name"
                                        onChange={e => handleInputChange(e, i, "first_name")}
                                        required={true}
                                        value={x?.first_name}
                                    />
                                </div>

                                <div className="col-md-2 col-sm-12">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Last Name"
                                        placeholder="Last name"
                                        onChange={e => handleInputChange(e, i, "last_name")}
                                        required={true}
                                        value={x?.last_name}
                                    />
                                </div>

                                <div className="col-md-2 col-sm-12">
                                    <input
                                        className="form-control"
                                        name="designation"
                                        placeholder="Designation"
                                        onChange={e => handleInputChange(e, i, "designation")}
                                        required={true}
                                        value={x?.designation}
                                    />
                                </div>

                                {console.log(x)}
                                <div className="col-md-2 col-sm-12">
                                    <FileUpload
                                        id={"addAttachment" + i}
                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                        documentUploadUrl={documentUploadUrl}
                                        documentUrlData={documentUrlData}
                                        onChange={(val) =>
                                            saveImage(val, i)
                                        }
                                        prefilledFilename={x?.image_url !== "" ? "Image Uploaded": (isEdit && viewDetails !== null && x?.image_url !== "" ?
                                            ("Image Uploaded") : x?.image_url)
                                    }
                                        // value={x?.image_url !== "" ? x?.image_url: (isEdit && x?.image_url === "" ? viewDetails[0]?.members[i]?.image_url : x?.image_url)}
                                    >
                                                        <span className="btn btn-transparent">
                                                            {localization.image}
                                                        </span>
                                    </FileUpload>
                                </div>

                                {/* <div className="btn-box"> */}
                                {inputMemberList.length !== 1 &&
                                    <div className="col-md-2 col-sm-5">
                                        <button
                                            onClick={() => handleRemoveClick(i)}
                                            className="mr10 btn btn-sm btn-danger">Remove
                                        </button>
                                    </div>
                                }
                                {inputMemberList.length - 1 === i &&
                                    <div className="col-md-2 col-sm-5">
                                        <button className="btn btn-sm btn-primary"
                                                onClick={handleAddClick}>Add
                                        </button>
                                    </div>
                                }
                                {/* </div> */}
                            </div>
                        );
                    })}
                </>
            ) : (addMembers === 2) ?
                ""
                : null}
        </>
    )
}

export default MemberDetails